/** Joins full class names, skipping the ones a part does not apply. */
export function joinClassNames(...classNames) {
    return classNames.filter(className => className !== undefined && className.length > 0).join(' ');
}
//# sourceMappingURL=joinClassNames.js.map